(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature--content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      let quickViewButtons = document.querySelectorAll('.feature-contentblocks__block__quickview');
      quickViewButtons.forEach(z => {
          z.addEventListener('click',function(e){
              let product_id;
              if( e.target.tagName === 'BUTTON'){
                  product_id = e.target.getAttribute('data-product-id');
              }else{
                  product_id = e.target.closest('button').getAttribute('data-product-id');
              }
              if(!product_id) return;
              // window.$triggerQuickViewModal(product_id);
              let tile = e.target.closest('.feature-contentblocks__block');
              tile.querySelector('.pdp-feature-contentblocks__content__product-tile .quick-add__submit').click();

          })
      })
      var videos = document.querySelectorAll('.video--autoplay');
      videos.forEach(video => {
        let video_wrapper = video.closest('.feature-contentblocks__image');
        video.muted = true;
        video.play();
        video.setAttribute('data-state','play');
        video.setAttribute('data-state-reload','false');
        if( video_wrapper ){
          video_wrapper.setAttribute('data-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
          video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
        }

        if( video_wrapper ){
          let playButton = video_wrapper.querySelector('.video-play-pause');
          if( playButton ){
            playButton.addEventListener('click',function(){
              if (video.paused == true) {
                // Play the video
                video.play();
                video.setAttribute('data-state','play');
                video.setAttribute('data-state-reload','false');
                video_wrapper.setAttribute('data-state','play');

                // Update the button text to 'Pause'
                this.setAttribute('data-button-state','play');
                this.setAttribute('data-button-state-reload','false');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
              } else {
                // Pause the video
                video.pause();
                video.setAttribute('data-state','pause');
                video_wrapper.setAttribute('data-state','pause');

                // Update the button text to 'Play'
                this.setAttribute('data-button-state','pause');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
              }
            });
          }
        }
      });

  });
  
  /* YouTube modal: delegated so it survives the theme re-rendering the page */
  (function () {
    if (window.__featureYtModal) return;
    window.__featureYtModal = true;

    function dialogFor(btn) {
      var id = btn.getAttribute('commandfor');
      return id ? document.getElementById(id) : null;
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('button.subheadline-link[commandfor^="youtube_dialog__"]');
      if (openBtn) {
        var dialog = dialogFor(openBtn);
        if (!dialog) return;
        e.preventDefault();
        var container = dialog.querySelector('.player-container');
        var videoId = dialog.getAttribute('data-video-id');
        if (container && videoId && !container.querySelector('iframe')) {
          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&playsinline=1';
          iframe.title = 'YouTube video';
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('frameborder', '0');
          container.appendChild(iframe);
        }
        if (!dialog.open) dialog.showModal();
        return;
      }

      var closeBtn = e.target.closest('.youtube_dialog button[command="close"]');
      if (closeBtn) {
        var d = closeBtn.closest('dialog');
        if (d && d.open) d.close();
        return;
      }

      /* click on the backdrop closes the modal */
      if (e.target.matches && e.target.matches('dialog.youtube_dialog[open]')) {
        e.target.close();
      }
    });

    /* stop playback on close (Esc, close button or backdrop) by removing the iframe */
    document.addEventListener('close', function (e) {
      if (e.target.matches && e.target.matches('dialog.youtube_dialog')) {
        var c = e.target.querySelector('.player-container');
        if (c) c.innerHTML = '';
      }
    }, true);
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature--hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var videos = document.querySelectorAll('.video--autoplay');
  videos.forEach(video => {
    video.muted = true;
    video.play();
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero--carousel"] && !Shopify.designMode) return;
  try {
    
function advanceToDot(button) {
   
    let pagination_index = button.getAttribute('data-pagination-index');
    if( pagination_index == '1' ){
        pagination_index = 0;
    }
    let carousel = button.closest('.hero-carousel--outer');
    let carouselItemWidth = carousel.querySelectorAll('.hero-carousel')[0].clientWidth;
    carousel.scrollLeft = carouselItemWidth * pagination_index;
}
document.addEventListener("DOMContentLoaded", function() {
  var videos = document.querySelectorAll('.video--autoplay');
  if( videos ){
      videos.forEach(video => {
        video.muted = true;
        video.play();
        let video_wrapper = video.closest('.hero-carousel__video');
        video.setAttribute('data-state','play');
        video.setAttribute('data-state-reload','false');
        if( video_wrapper ){
          video_wrapper.setAttribute('data-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state','play');
          video_wrapper.querySelector('.video-play-pause').setAttribute('data-button-state-reload','false');
          video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';

          let playButton = video_wrapper.querySelector('.video-play-pause');
          if( playButton ){
            playButton.addEventListener('click',function(){
              if (video.paused == true) {
                // Play the video
                video.play();
                video.setAttribute('data-state','play');
                video.setAttribute('data-state-reload','false');
                video_wrapper.setAttribute('data-state','play');

                // Update the button text to 'Pause'
                this.setAttribute('data-button-state','play');
                this.setAttribute('data-button-state-reload','false');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Pause video';
              } else {
                // Pause the video
                video.pause();
                video.setAttribute('data-state','pause');
                video_wrapper.setAttribute('data-state','pause');

                // Update the button text to 'Play'
                this.setAttribute('data-button-state','pause');
                video_wrapper.querySelector('.video-play-pause__text').innerHTML = 'Play video';
              }
            });
          }
        }
      })
  }
  var carousels = document.querySelectorAll('.hero-carousel--outer');
  if( carousels ){
    carousels.forEach( carousel => {
        let dots = carousel.querySelectorAll('.hero-carousel--nav__pagination-dot');
        dots.forEach(dot => {
            dot.addEventListener('click',function(e){
                advanceToDot(e.target);
            });
        });

        carousel.addEventListener('scrollsnapchange', () => {
            let carousel_item = carousel.querySelectorAll('.hero-carousel')[0];
            let carousel_item__width = carousel_item.clientWidth;
            let scroll_over_width = carousel.scrollLeft / carousel.clientWidth;
            let index = Math.round(carousel.scrollLeft / carousel_item__width);

            let pagination_dots = carousel.querySelectorAll('.hero-carousel--nav__pagination-dot');
            let the_nav = carousel.querySelector('.hero-carousel--nav');
            
                if( index || index === 0 ) {
                    index = index + 1;
                    pagination_dots.forEach(dot => {
                        let currentIndex;
                        if( dot.getAttribute('data-pagination-index') ){
                            currentIndex = Number( dot.getAttribute('data-pagination-index') );
                        }
                        the_nav.setAttribute('data-current-slide',index)
                        if( currentIndex && currentIndex === index ) {
                            // pagination_dots[currentIndex].classList.add('selected');
                            // console.log('pagination_dots[currentIndex]',pagination_dots[currentIndex])
                            // pagination_dots[currentIndex].setAttribute('data-is-selected','true');
                            // alert('index: '+index)
                        }else{
                            // dot.classList.remove('selected');
                            // dot.setAttribute('data-is-selected','false');
                        }
                    });
                }
        });
    });
    }
});

  } catch(e) { console.error(e); }
})();
})();
